module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/mailchimp/list/list-categories/list-categories.component.scss
// module id = ./src/app/mailchimp/list/list-categories/list-categories.component.scss
// module chunks = main